import comingSoonGif from "@assets/gifs/coming-soon.gif";
import { ComingSoon } from "@cpj-ai/panel-npm-package";

const BillingHistoryTabContent = () => {
  return (
    <ComingSoon
      gif={comingSoonGif}
      title="Financial"
      subTitle="Coming Soon... "
      description="We are excited to share our plans for enhancing your experience! While we're currently developing an automated financial management feature for the future. We're working hard to bring you these automated tools that will make managing your finances even more convenient and efficient. Stay tuned for these upcoming improvements!"
    />
  );
};

export default BillingHistoryTabContent;
